import React, { FC, useState } from 'react'
import { Provider } from 'react-redux'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'

import { makeStore } from '@/redux/store'

type Props = {
  children: React.ReactNode
}

export const ReduxProvider: FC<Props> = ({ children }) => {
  const [store] = useState(() => makeStore())
  const [persistor] = useState(() => persistStore(store))

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>{children}</PersistGate>
    </Provider>
  )
}
